import { Scale, Sparkles } from "lucide-react";

const Header = () => {
  return (
    <div className="relative mb-12">
      {/* Decorative line */}
      <div className="absolute -left-8 top-8 w-1 h-24 bg-gradient-to-b from-[#7C3AED] via-[#06B6D4] to-transparent rounded-full"></div>

      <div className="pl-4">
        {/* Tag line */}
        <div className="flex items-center gap-2 mb-4">
          <div className="h-px w-8 bg-[#7C3AED]"></div>
          <span className="text-xs uppercase tracking-[3px] text-[#7C3AED] font-medium">
            Legal Intelligence
          </span>
          <Sparkles className="h-3 w-3 text-[#06B6D4]" />
        </div>

        {/* Main title - left aligned */}
        <div className="flex items-end gap-4 mb-3">
          <h1 className="text-[64px] font-bold tracking-[-3px] leading-none bg-gradient-to-br from-white via-[#E2E8F0] to-[#94A3B8] bg-clip-text text-transparent">
            Is It
          </h1>
          <div className="relative">
            <h1 className="text-[64px] font-bold tracking-[-3px] leading-none bg-gradient-to-r from-[#7C3AED] to-[#06B6D4] bg-clip-text text-transparent">
              Legal?
            </h1>
            {/* Underline accent */}
            <div className="absolute -bottom-1 left-0 right-0 h-[3px] bg-gradient-to-r from-[#7C3AED] to-[#06B6D4] rounded-full"></div>
          </div>
          <Scale
            className="h-10 w-10 text-[#7C3AED] mb-2 opacity-60"
            strokeWidth={1.5}
          />
        </div>

        {/* Subtitle with different positioning */}
        <p className="text-[#64748B] text-base max-w-md leading-relaxed">
          Navigate complex regulations with{" "}
          <span className="text-[#A78BFA]">AI-powered</span> legal analysis. Get
          instant answers backed by verified sources.
        </p>

        {/* Stats row */}
        <div className="flex items-center gap-6 mt-6">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-[#10B981] animate-pulse"></div>
            <span className="text-xs text-[#94A3B8]">Real-time analysis</span>
          </div>
          <div className="h-3 w-px bg-[#2D2D4A]"></div>
          <span className="text-xs text-[#94A3B8]">16+ jurisdictions</span>
          <div className="h-3 w-px bg-[#2D2D4A]"></div>
          <span className="text-xs text-[#94A3B8]">Verified sources</span>
        </div>
      </div>
    </div>
  );
};

export default Header;
